import { Pipe, PipeTransform } from '@angular/core';
import { Gradient } from './gradient-picker.types';

@Pipe({
    name: 'gradientCss',
    standalone: true,
})
export class GradientCssPipe implements PipeTransform {
    transform(value: Gradient | null | undefined): string {
        if (!value || !value.colors?.length) return 'linear-gradient(135deg, hsl(270 70% 45%) 0%, hsl(280 85% 65%) 100%)';

        const sortedStops = [...value.colors].sort((a, b) => a.position - b.position);
        const colorStops = sortedStops.map(stop => `${stop.color} ${stop.position}%`).join(', ');

        if (value.gradientType === 'radial') {
            return `radial-gradient(circle, ${colorStops})`;
        }

        return `linear-gradient(${value.angle}deg, ${colorStops})`;
    }
}
